import React from "react";

class UpdatesFilter extends React.Component {
  constructor(state, props) {
    super(state, props);
    this.state = { search: "all", active: null };
  }

  onClickSearchFilter(name) {
    this.setState({
      search: name
    });
    this.onChangeSearch(name);
  }

  //pass the updated search value back to parent (CheckRouteAndShowFilter)
  onChangeSearch = value => {
    this.props.onChangeSearch(value);
  };

  componentDidMount() {
    //current filter value
    this.setState({
      search: this.props.search
    });
  }

  render() {
    return (
      <div>
        <div className="row text-center centre-row-margin" >
          <div className="filterOutline">
            <span className="text-muted filterText">
              <b>Updates </b>&nbsp;
              <select className="select-styling" onChange={evt => this.onClickSearchFilter(evt.target.value)} value={this.props.search}>
                <option value="ace">Aim for the Ace!</option>
                <option value="doremi">DoReMi Fantasy</option>
	        <option value="koryu">Koryu No Mimi</option>
                <option value="mickey3">Magical Quest 3</option>
                <option value="miracle">Miracle Girls</option>
                <option value="undercover">Undercover Cops</option>
                <option value="all">View All</option>
            </select>
           </span>
          </div>
        </div>
      </div>
    );
  }
}

export default UpdatesFilter;



// WEBPACK FOOTER //
// ./src/lib/UpdatesFilter.js